import React, { useState } from 'react';
import { Text, TouchableOpacity, View, StyleSheet, ActivityIndicator } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import I18n from 'i18n-js';

const PromptButton = ({ testID, label, onPress, disabled }) => (
  <TouchableOpacity style={styles.okButton} testID={testID} onPress={onPress} disabled={disabled}>
    <LinearGradient
      locations={[0, 0.7, 1]}
      start={{ x: 0, y: 0 }}
      end={{ x: 0, y: 1 }}
      colors={['#ffffff', '#f5f5f5', '#e0e0e0']}
      style={styles.actionButton}>
      <Text style={styles.buttonText}>{label}</Text>
    </LinearGradient>
  </TouchableOpacity>
);

const CartErrorPrompt = ({ setShowPrompt, assignedOrderCount = 0, onReset }) => {
  const [confirming, setConfirming] = useState(false);
  const [resetting, setResetting] = useState(false);
  const [resetError, setResetError] = useState(null);
  const canReset = assignedOrderCount > 0 && onReset;

  const handleReset = async () => {
    setResetting(true);
    setResetError(null);
    const result = await onReset();
    if (!result?.ok) {
      setResetting(false);
      setConfirming(false);
      setResetError(result?.error || I18n.t('scanToCart.cartResetFailed'));
    }
  };

  let message = I18n.t('scanToCart.cartUpdateError');
  if (canReset) {
    message = confirming
      ? I18n.t('scanToCart.cartResetConfirm')
      : I18n.t('scanToCart.cartAssignedOrders', { count: assignedOrderCount });
  }

  return (
    <View style={styles.responseView}>
      <LinearGradient
        locations={[0, 1]}
        colors={['rgb(207,68,55)', 'rgb(122,40,40)']}
        style={styles.promptContainer}>
        <View style={styles.cancelIcon}>
          <TouchableOpacity testID="CloseErrorPrompt" onPress={() => setShowPrompt(false)}>
            <i
              className="icon-cancel"
              style={{ fontSize: 26, color: '#ffffff' }}></i>
          </TouchableOpacity>
        </View>

        <View style={styles.messageContainer}>
          <Text style={styles.messageText}>{message}</Text>
          {resetError && <Text style={styles.messageText}>{resetError}</Text>}
        </View>

        {!canReset && (
          <PromptButton
            testID='OkButton'
            label={I18n.t('scanToCart.okButtonLabel')}
            onPress={() => setShowPrompt(false)}
          />
        )}
        {canReset && resetting && <ActivityIndicator size="small" color="#ffffff" />}
        {canReset && !resetting && !confirming && (
          <>
            <PromptButton
              testID='ResetCartButton'
              label={I18n.t('scanToCart.resetCartButton')}
              onPress={() => setConfirming(true)}
            />
            <PromptButton
              testID='CancelResetCartButton'
              label={I18n.t('scanToCart.cancelLabel')}
              onPress={() => setShowPrompt(false)}
            />
          </>
        )}
        {canReset && !resetting && confirming && (
          <>
            <PromptButton
              testID='ConfirmResetCartButton'
              label={I18n.t('scanToCart.ConfirmReset')}
              onPress={handleReset}
            />
            <PromptButton
              testID='CancelResetCartButton'
              label={I18n.t('scanToCart.CancelReset')}
              onPress={() => setConfirming(false)}
            />
          </>
        )}
      </LinearGradient>
    </View>
  );
};

const styles = StyleSheet.create({
  responseView: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    zIndex: 1000,
    width: '100%',
    height: '100%'
  },
  promptContainer: {
    paddingHorizontal: 20,
    paddingVertical: 15,
    width: '90%',
    maxWidth: 550,
    marginTop: 0,
    borderRadius: 5,
    elevation: 5,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    position: 'relative'
  },
  cancelIcon: {
    display: 'flex',
    alignSelf: 'flex-end'
  },
  messageContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 20,
    padding: 15,
  },
  messageText: {
    fontFamily: 'Poppins_300Light',
    fontSize: 18,
    textAlign: 'center',
    color: '#ffffff',
    fontWeight: '600',
    marginBottom: 10
  },
  okButton: {
    width: '100%',
    alignItems: 'center',
    marginTop: 10
  },
  actionButton: {
    borderRadius: 20,
    paddingVertical: 8,
    paddingHorizontal: 16,
    minWidth: '40%',
    alignItems: 'center',
    justifyContent: 'center'
  },
  buttonText: {
    color: '#d40202',
    fontFamily: 'Poppins_300Light',
    fontSize: 16,
    fontWeight: '500'
  }
});

export default CartErrorPrompt;
